export default __webpack_public_path__ + "static/media/exclamation-triangle.d89fe752.svg";